import { render } from "./CallerNumberAnalyser.vue?vue&type=template&id=181e6a02"
import script from "./CallerNumberAnalyser.vue?vue&type=script&lang=js"
export * from "./CallerNumberAnalyser.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__